import { Dialog } from "@mui/material";
import { useState } from "react";
import TermsAndPolicy from "../../shared/TermsAndPolicy";
import { trackEvent } from "../../utils/AmpAnalytics";

export function PrivacyPolicy({
  variant = "dark",
  inline = false,
}: {
  variant?: "dark" | "light";
  inline?: boolean;
}) {
  const textColor =
    variant === "light"
      ? "text-xs text-gray-600 underline hover:text-gray-700"
      : "text-white underline hover:opacity-80";

  const normalText =
    variant === "light"
      ? "text-xs text-gray-600"
      : "text-white";

  const [dialogState, setDialogState] = useState({
    open: false,
    header: "",
  });

  return (
    <>
      <span className="inline-flex gap-2 text-sm justify-center items-center">
        <button
          onClick={() =>{
            trackEvent("Navigating to Privacy Policy")
            setDialogState({ open: true, header: "Privacy Policy" })
          }}
          className={`${textColor} cursor-pointer whitespace-nowrap`}
        >
          Privacy Policy
        </button>
        {inline ? (
          <span className={`${normalText} underline-none`}>and</span>
        ) : (
          <span className={normalText}>•</span>
        )}

        <button
          onClick={() => {
            trackEvent("Navigating to Terms and Conditions")
            setDialogState({ open: true, header: "Terms And Services" })}
          }
          className={`${textColor} cursor-pointer whitespace-nowrap`}
        >
          Terms and Conditions
        </button>
      </span>

      <Dialog
        open={dialogState.open}
        onClose={() => setDialogState({ header: "", open: false })}
      >
        <TermsAndPolicy
          type={dialogState.header}
          onClose={() => setDialogState({ header: "", open: false })}
        />
      </Dialog>
    </>
  );
}